import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import apiService from "../APIService";
import deliveryTimeIcon from "../../images/img/deliverytime-icon.svg";
import Banner from "../FormFields/Banner";
import MessageA1 from "./MessageCodes/MessageA1";
import MessageA2 from "./MessageCodes/MessageA2";
import MessageA3 from "./MessageCodes/MessageA3";
import MessageA3D from "./MessageCodes/MessageA3d";
import MessageRedirect from "./MessageCodes/MessageRedirect";
import MessageA5 from "./MessageCodes/MessageA5";
import MessageA13 from "./MessageCodes/MessageA13";
import MessageA14 from "./MessageCodes/MessageA14";
import MessageA15 from "./MessageCodes/MessageA15";
import MessageA15I from "./MessageCodes/MessageA15I";
import "../HelpAssistant/HelpAssistant.css";
import MessageA39 from "./MessageCodes/MessageA39";
import MessageA17 from "./MessageCodes/MessageA17";
import MessageA22 from "./MessageCodes/MessageA22";
import MessageA24 from "./MessageCodes/MessageA24";
import RechargeToast from "../RechargeToast";
import MessageA19 from "./MessageCodes/MessageA19";
import MessageA23 from "./MessageCodes/MessageA23";
import MessageA23R from "./MessageCodes/MessageA23R";
import MessageA42 from "./MessageCodes/MessageA42";
import MessageA6 from "./MessageCodes/MessageA6";
import MessageA7 from "./MessageCodes/MessageA7";
import MessageA21 from "./MessageCodes/MessageA21";
import moment from "moment";
import MessageA48 from "./MessageCodes/MessageA48";
import MessageA58 from "./MessageCodes/MessageA58";
import MessageA59 from "./MessageCodes/MessageA59";
import MessageA60 from "./MessageCodes/MessageA60";
import MessageA61 from "./MessageCodes/MessageA61";
import MessageA62 from "./MessageCodes/MessageA62";
import MessageA63 from "./MessageCodes/MessageA63";
import userIcon from "../../../src/images/img/user.svg";
import MessageA80 from "./MessageCodes/MessageA80";
import secureLocalStorage from "react-secure-storage";

import MessageA14CHR from "./MessageCodes/MessageA14CHR";
import MessageA1icon from "./MessageCodes/MessageA1icon";
import MessageA444 from "./MessageCodes/MessageA444";
import MessageA21I from "./MessageCodes/MessageA21I";
import MessageA81 from "./MessageCodes/MessageA81";
import MessageA13s from "./MessageCodes/MessageA13s";

import MessageA1RequestTrack from "./MessageCodes/MessageA1RequestTrack";




import WC26TABLE from "./MessageCodes/WC26TABLE";
import A1ListSchedule from "./MessageCodes/A1ListSchedule";
import A23SingleSelect from "./MessageCodes/A23SingleSelect";
import A14input from "./MessageCodes/A14input";
import A1Event from "./MessageCodes/A1Event";

const Conversation = (props) => {
  const [currentData, setCurrentData] = useState([]);
  const timeCurrent =
    new Date().toLocaleTimeString("en-us").split(":")[0] +
    ":" +
    new Date().toLocaleTimeString("en-us").split(":")[1] +
    " " +
    new Date().toLocaleTimeString("en-us").substr(-2);
  const [messages, setMessages] = useState([]);
  const [initalState, setInitalState] = useState([]);
  const [textOnClick, setTextOnClick] = useState();
  const [showBanner, setShowBanner] = useState(false);
  const [bannerData, setBannerData] = useState();
  const [showRecharge, setShowRecharge] = useState(false);
  const [rechargeData, setRechargeData] = useState();
  const [historyData, setHistoryData] = useState();
  const [showHistory, setShowHistory] = useState(props.showHistory);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("chatApiLoading", { detail: isLoading }));
    if (isLoading) {
      setTimeout(() => scrollToBottom(), 100);
    }
  }, [isLoading]);
  const [initialLoading, setInitialLoading] = useState(false);
  const [historyFirstData, setHistoryFirstData] = useState([]);
  const [auth, setAuth] = useState(props.auth);
  const [textMessage, setTextMessage] = useState(props.textMessage);
  const [enableTextBox, setEnableTextBox] = useState(false);
  const [chatEnd, setChatEnd] = useState(false);
  const [disableBtns, setDisableBtns] = useState(false);
  const [finalTimerFlag, setFinalTimerFlag] = useState(false);
  const [isFallback, setIsFallback] = useState(false);
  const [subTextOnClick, setSubTextOnClick] = useState();
  const [isReplacingLoader, setIsReplacingLoader] = useState(false);
  const [nudgeSet, setNudgeSet] = useState(false);

  let idleTimer;
  let secondIdleTimer;
  let finalTimer;
  const messagesEndRef = useRef(null);
  const inputValue = useRef(null);

  const [idleTime, setIdleTime] = useState(0);

  useEffect(() => {
    if (currentData && !nudgeSet) {
      const nudgeItem = currentData.find(item => item.uiCommand === "A13Nudge");
      if (nudgeItem && props.setNudgeData) {
        props.setNudgeData(nudgeItem);
        setNudgeSet(true);
      }
    }
  }, [currentData, nudgeSet]);

  useEffect(() => {
    let isFinalTimerTriggered = false;

    const handleUserActivity = () => {
      clearTimeout(idleTimer);
      clearTimeout(secondIdleTimer);

      if (!chatEnd) {
        setIdleTime(0);
      }

      if (!chatEnd && !isFinalTimerTriggered) {
        clearTimeout(finalTimer);

        idleTimer = setTimeout(() => {
          setIdleTime(idleTime + 1);
          let initialArray = [];
          initialArray.push({
            uiCommand: "idle",
            text: "Hey there! We're eagerly waiting for you & we'd love to help you with your query.",
          });
          setCurrentData(initialArray);
        }, 5 * 60 * 1000);

        secondIdleTimer = setTimeout(() => {
          setIdleTime(idleTime + 1);
          let initialArray = [];
          initialArray.push({
            uiCommand: "idle",
            text: "Hey there! We're eagerly waiting for you & we'd love to help you with your query.",
          });
          setCurrentData(initialArray);
        }, 10 * 60 * 1000);

        finalTimer = setTimeout(() => {
          setIdleTime(idleTime + 1);
          setDisableBtns((val) => !val);
          props.setIsSessionExpired(true);
          isFinalTimerTriggered = true;
          setFinalTimerFlag(true);
          props.setShowIdlePopup(true);
        }, 30 * 60 * 1000);
      }
    };

    const resetIdleTimer = () => {
      handleUserActivity();
    };

    if (!finalTimerFlag && !chatEnd && !props.isChatWithUs) {
      console.log("INSIDE add event listner", finalTimerFlag, chatEnd);
      // window.addEventListener("mousemove", resetIdleTimer);
      // window.addEventListener("keydown", resetIdleTimer);
      window.addEventListener("click", resetIdleTimer);
    }

    console.log("First render", chatEnd);
    console.log("IS FINAL timer triggerded? ", isFinalTimerTriggered);

    if (chatEnd) {
      console.log("Re-render");
      clearTimeout(idleTimer);
      clearTimeout(secondIdleTimer);
      clearTimeout(finalTimer);
      // window.removeEventListener("mousemove", resetIdleTimer);
      // window.removeEventListener("keydown", resetIdleTimer);
      window.addEventListener("click", resetIdleTimer);
    }
    return () => {
      clearTimeout(idleTimer);
      clearTimeout(secondIdleTimer);
      clearTimeout(finalTimer);
      // window.removeEventListener("mousemove", resetIdleTimer);
      // window.removeEventListener("keydown", resetIdleTimer);
      window.addEventListener("click", resetIdleTimer);
    };
  }, []);

  useEffect(() => {
    if (finalTimerFlag) {
      let n = document.getElementsByClassName("action-tab");

      for (let i = 0; i < n.length; i++) {
        n[i].disabled = true;
        n[i].style.cursor = "not-allowed";
      }
    }
  }, [finalTimerFlag]);

  window.s360BannerCallback = (code) => {
    handleClick(code);
    if (code === "1.6.1.1.1.12.13.17") setTextOnClick("Register Now");
    else if (code === "1.6.1.1.1.12.13.17.1.1") setTextOnClick("Done");
  };

  useEffect(() => {
    setAuth(props.auth);
  }, [props.auth]);

  useEffect(() => {
    if (currentData?.length === 0) setCurrentData(props.chatData);
  }, [props.chatData]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    setCurrentData(props.currentData);
  }, [props.currentData]);

  useEffect(() => {
    if (props.login && !props.outSideLink && !props.action) {
      setInitialLoading(true);
      apiService.initialState().then((response) => {
        const data =
          response.data &&
          response.data.chatResponse &&
          response.data.chatResponse.entries;

        props.handleInputBox(response?.data?.chatResponse?.enableDefaultTextBox);

        setInitialLoading(false);
        data &&
          data.map((i) => {
            if (i.uiCommand === "A41") {
              setShowBanner(true);
              setBannerData(i);
            }
            if (i.uiCommand === "A40") {
              setShowRecharge(true);
              setRechargeData(i);
            }
          });
        setCurrentData(data);
        data &&
          data.map((item, index) => item.code && initalState.push(item.code));
      });
    }
  }, [props.login]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    scrollToBottom();
    if (currentData !== undefined && currentData[0]?.uiCommand !== undefined) {
    }
  }, [currentData, props.sendText]);

  const handleRefresh = (code,input) => {
    setIsLoading(true);
    if (auth) {
      apiService.refreshChat().then((response) => {
        apiService.chat(code,input).then((response) => {
          setIsLoading(false);
          const data =
            response.data &&
            response.data.chatResponse &&
            response.data.chatResponse.entries;
          setCurrentData(data);
          props.handleInputBox(
            response?.data?.chatResponse?.enableDefaultTextBox
          );
        });
      });
    } else {
      apiService.chat(code,input).then((response) => {
        setIsLoading(false);
        const data =
          response.data &&
          response.data.chatResponse &&
          response.data.chatResponse.entries;
        setCurrentData(data);
        props.handleInputBox(
          response?.data?.chatResponse?.enableDefaultTextBox
        );
      });
    }
  };

  const handleClick = async (code, input, tag) => {
    clearTimeout(idleTimer);
    clearTimeout(secondIdleTimer);
    clearTimeout(finalTimer);

    if (isFallback) {
      setIsFallback(false);
    }

    setTextOnClick(undefined);
    setIsLoading(true);
    let n = document.getElementsByClassName("action-tab");

    for (let i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.cursor = "not-allowed";
      // n[i].style.opacity = 0.5;
      n[i].style.pointerEvents = "none";
    }
    setSubTextOnClick('')
    if (initalState.includes(code) && !props.sth) {
      handleRefresh(code ,input);
      return;
    } else if (historyFirstData.includes(code) && props.sth) {
      handleRefresh(code ,input);
      return;
    }

    if (tag === "A58") {
      const response = await apiService.chatPost(code, input);
      setIsLoading(false);
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;
      props.handleInputBox(response?.data?.chatResponse?.enableDefaultTextBox);
      if (response?.data?.chatResponse?.end === true && !chatEnd) {
        setChatEnd((val) => !val);
      }

      if (response?.data?.chatResponse?.notif?.text) {
        props.setIsDunningToast(true);
        props.setUserNotification(response?.data?.chatResponse?.notif);
      }

      setCurrentData(data);
      setEnableTextBox(false);
    } else if (tag === "A59" || tag === "A63") {
      console.log("checking confirm buttons logs", code, input);
      const response = await apiService.chatPostPacks(code, input);
      setIsLoading(false);
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;

      props.handleInputBox(response?.data?.chatResponse?.enableDefaultTextBox);

      if (response?.data?.chatResponse?.end === true && !chatEnd) {
        setChatEnd((val) => !val);
      }

      if (response?.data?.chatResponse?.notif?.text) {
        props.setIsDunningToast(true);
        props.setUserNotification(response?.data?.chatResponse?.notif);
      }

      setCurrentData(data);
      setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);
    } else if (tag === "A444") {
      const response = await apiService.chat(code, input);
      setIsLoading(false);
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;
      props.handleInputBox(response?.data?.chatResponse?.enableDefaultTextBox);
      if (response?.data?.chatResponse?.notif?.text) {
        props.setIsDunningToast(true);
        props.setUserNotification(response?.data?.chatResponse?.notif);
      }
      setCurrentData(data);
      setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);
      if (response?.data?.chatResponse?.end === true && !chatEnd) {
        setChatEnd((val) => !val);
      }
    } else if (tag === "A433") {
      const response = await apiService.chatPostPacks(code, input);
      setIsLoading(false);
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;
      props.handleInputBox(response?.data?.chatResponse?.enableDefaultTextBox);
      if (response?.data?.chatResponse?.notif?.text) {
        props.setIsDunningToast(true);
        props.setUserNotification(response?.data?.chatResponse?.notif);
      }
      setCurrentData(data);
      setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);
      if (response?.data?.chatResponse?.end === true && !chatEnd) {
        setChatEnd((val) => !val);
      }
    } else {
      const response = await apiService.chat(code, input);
      setIsLoading(false);
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;

      props.handleInputBox(response?.data?.chatResponse?.enableDefaultTextBox);

      if (response?.data?.chatResponse?.notif?.text) {
        props.setIsDunningToast(true);
        props.setUserNotification(response?.data?.chatResponse?.notif);
      }

      setCurrentData(data);
      setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);

      if (response?.data?.chatResponse?.end === true && !chatEnd) {
        setChatEnd((val) => !val);
      }
    }
  };

  useEffect(() => {
    if (finalTimerFlag) {
      setFinalTimerFlag(false);
    }
    if (props.textMessage.key1) {
      let data = {
        data: "John",
        uiCommand: "A7",
        text: props.textMessage.key1,
      };
      setCurrentData([data]);

      if (
        props.textMessage.dontSend === undefined &&
        props.textMessage !== ""
      ) {
        apiService.chat(props.textMessage.code || null, props.textMessage).then((response) => {
          setIsLoading(false);

          if (response?.data?.chatResponse?.enableColorChange) {
            setIsFallback(true);
          }

          if (response?.data?.chatResponse?.notif?.text) {
            props.setIsDunningToast(true);
            props.setUserNotification(response?.data?.chatResponse?.notif);
          }

          const data =
            response.data &&
            response.data.chatResponse &&
            response.data.chatResponse.entries;
          props.handleInputBox(
            response?.data?.chatResponse?.enableDefaultTextBox
          );
          setCurrentData(data);
          setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);

          var parsedData = null;
          if (data[2] !== undefined && data[2].uiCommand === "A58") {
            parsedData = JSON.parse(JSON.stringify(data[2])).text_data;
            let temp = new Object();
            temp["selectedLanguages"] =
              parsedData?.filter?.language?.selectedLanguages;
            temp["selectedGenre"] = parsedData?.filter?.genre.selectedGenre;

            localStorage.setItem(
              "selectedLanguagesAndGenresTemp",
              JSON.stringify(temp)
            );
          }
        });
      }
      setFinalTimerFlag(true);
    }
    setTextOnClick();
  }, [props.textMessage]);

  const checkImage = (textOnClick) =>{

    if(!textOnClick) return false;
    if(textOnClick.includes("http://localhost:3000/") ||
    textOnClick.includes("https://d1mtg6g85qkrw7.cloudfront.net/") ||
    textOnClick.includes("https://qa-portal.tataplay.com/dth/help")||
    textOnClick.includes("https://www.tataplay.com/dth/help")||
    textOnClick.includes("https://helpchat.tataplay.com")){
      return true
    }
    return false
  }

  let data;

  data =
    currentData && currentData[0]?.uiCommand !== "idle"
      ? <ul style={{ listStyle: "none", padding: 0, margin: 0, width: "100%" }}>{currentData.map((item, index) => {
          return (
            <li style={{ width: "100%" }}>
              {(index === 0 && textOnClick !== undefined) ||
              textOnClick === "" ? (
                <div className="onclick-openwrapp section0 userchatmsg0_1 userchatmsg">
                  <div
                    className="onclick-inner"
                    style={{
                      display: "flex",
                      width: "100%",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                   <span className="packs-img">
                      {localStorage.getItem("userName") &&
                      localStorage.getItem("userName") !== "Testing" ? (
                        localStorage
                          .getItem("userName")
                          .match(/\b(\w)/g)
                          ?.join("")
                      ) : (
                        <img height="15" width="15" src={userIcon} />
                      )}
                    </span>
                      {checkImage(textOnClick) ? (
                        <div className="packs-text">
                          <img style={{ width: "160px" }} src={textOnClick} alt="click" />
                        </div>

                      ) : (
                        <span className="packs-text" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", textAlign: "left", width: subTextOnClick && '80%' }}>
                          <div style={{ display: "flex", alignItems: "flex-start", whiteSpace: "normal", wordBreak: "break-word", width: "100%" }}>
                            {textOnClick}
                          </div>
                          <div style={{ display: "flex", alignItems: "flex-start", fontSize: "11px", whiteSpace: "normal", wordBreak: "break-word", width: "100%", marginTop: '5px' }}>
                            {subTextOnClick}
                          </div>
                        </span>
                      )}
                  </div>
                  <div>
                    <div style={{}} className="delivery-time-first">
                      {timeCurrent}
                      <span>
                        <img
                          src={deliveryTimeIcon}
                          className="img-fluid"
                          alt=""
                        />
                      </span>
                    </div>
                  </div>
                </div>
              ) : null}

              {item.uiCommand === "A1" && (
                <MessageA1
                  item={item}
                  handleClick={handleClick}
                  setTextOnClick={setTextOnClick}
                  setSubTextOnClick={setSubTextOnClick}
                  disable={disableBtns}
                  isFallback={isFallback}
                  // ref={}
                />
              )}
               {item.uiCommand === "A1Event" && (
                <A1Event
                  item={item}
                  handleClick={handleClick}
                  setTextOnClick={setTextOnClick}
                  setSubTextOnClick={setSubTextOnClick}
                  disable={disableBtns}
                  isFallback={isFallback}
                  // ref={}
                />
              )}
              {item.uiCommand === "A1icon" && (
                <MessageA1icon
                  item={item}
                  handleClick={handleClick}
                  setTextOnClick={setTextOnClick}
                  disable={disableBtns}
                  isFallback={isFallback}
                  // ref={}
                />
              )}

              {item.uiCommand === "A81" && (
                <MessageA81
                  item={item}
                  setShowFeedbackPopUP={props.setShowFeedbackPopUP}
                />
              )}

              {item.uiCommand === "A2" && (
                <MessageA2
                  item={item}
                  handleClick={handleClick}
                  setTextOnClick={setTextOnClick}
                />
              )}
              {item.uiCommand === "A3" && (
                <MessageA3 item={item} index={index} disable={disableBtns} />
              )}
                {(item.uiCommand === "A444") && (
                <MessageA444 item={item} index={index} disable={disableBtns} handleClick={handleClick} inputValue={inputValue}  setTextOnClick={setTextOnClick} setChatClosed={props?.setChatClosed} setMinimized={props.setMinimized} setShowClose={props.setShowClose} scrollToBottom={scrollToBottom} setChatData={props.setChatData}/>
               
            )}

              {item.uiCommand === "A3d" && <MessageA3D item={item} />}

              {item.uiCommand === "A1RequestTrack" && (
                <MessageA1RequestTrack item={item} inputValue={inputValue} handleClick={handleClick} setTextOnClick={setTextOnClick} />
              )}
              {item.uiCommand === "A5" && (
                <MessageA5 item={item} inputValue={inputValue} />
              )}

              {item.uiCommand === "A6" && <MessageA6 item={item} />}

              {item.uiCommand === "A7" && (
                <MessageA7 item={item} setTextOnClick={setTextOnClick} />
              )}
              {item.uiCommand === "Redirect" && (
                <MessageRedirect
                  item={item}
                  handleClick={handleClick}
                  setTextOnClick={setTextOnClick}
                  isFallback={isFallback}
                />
              )}

              {item.uiCommand === "A39" && <MessageA39 item={item} />}

              {item.uiCommand === "A13" && (
                <MessageA13 item={item} inputValue={inputValue} />
              )}

              {item.uiCommand === "A13s" && (
                <MessageA13s item={item} inputValue={inputValue}  handleClick={handleClick}/>
              )}


              {item.uiCommand === "A14" && (
                <MessageA14 item={item} inputValue={inputValue} />
              )}

              {item.uiCommand === "A15" && (
                <MessageA15
                  item={item}
                  handleClick={handleClick}
                  setTextOnClick={setTextOnClick}
                  disable={disableBtns}
                  scrollToBottom={scrollToBottom}
                />
              )}

              {item.uiCommand === "A15I" && (
                <MessageA15I
                  item={item}
                  handleInputBox={props.handleInputBox}
                />
              )}

              {item.uiCommand === "A17" && <MessageA17 item={item} />}

              {item.uiCommand === "A19" && <MessageA19 item={item} />}

              {item.uiCommand === "A21" && (
                <MessageA21
                  item={item}
                  handleClick={handleClick}
                  setTextOnClick={setTextOnClick}
                />
              )}

              {item.uiCommand === "A21I" && (
                <MessageA21I
                  item={item}
                  handleClick={handleClick}
                  setTextOnClick={setTextOnClick}
                />
              )}

              {item.uiCommand === "A22" && (
                <MessageA22 item={item} inputValue={inputValue} />
              )}

              {item.uiCommand === "A23" && (
                <MessageA23
                  item={item}
                  handleClick={handleClick}
                  setTextOnClick={setTextOnClick}
                />
              )}

              {item.uiCommand === "A23R" && (
                <MessageA23R
                  item={item}
                  handleClick={handleClick}
                  setTextOnClick={setTextOnClick}
                />
              )}

              {item.uiCommand === "A24" && <MessageA24 item={item} />}

              {item.uiCommand === "A42" && (
                <MessageA42 item={item} setTextOnClick={setTextOnClick} />
              )}

              {item.uiCommand === "A48" && (
                <MessageA48
                  item={item}
                  handleClick={handleClick}
                  setTextOnClick={setTextOnClick}
                />
              )}

              {item.uiCommand === "A58" && (
                <MessageA58
                  item={item}
                  handleClick={handleClick}
                  tag={item.uiCommand}
                  enableDontSend={() => {
                    props.handleDontSend();
                  }}
                />
              )}
              {item.uiCommand === "A59" && (
                <MessageA59
                  item={item}
                  handleClick={handleClick}
                  tag={item.uiCommand}
                />
              )}
              {item.uiCommand === "A60" && (
                <MessageA60
                  item={item}
                  handleClick={handleClick}
                  tag={item.uiCommand}
                />
              )}
              {item.uiCommand === "A61" && (
                <MessageA61
                  item={item}
                  handleClick={handleClick}
                  tag={item.uiCommand}
                />
              )}
              {item.uiCommand === "A62" && (
                <MessageA62
                  item={item}
                  handleClick={handleClick}
                  tag={item.uiCommand}
                />
              )}
              {item.uiCommand === "A63" && (
                <MessageA63
                  item={item}
                  handleClick={handleClick}
                  tag={item.uiCommand}
                  confirmCode={item.code}
                />
              )}
              {item.uiCommand === "A14CHR" && (
                <MessageA14CHR item={item} inputValue={inputValue} />
              )}
              {item.uiCommand === "A14input" && (
                <A14input
                  item={item}
                  inputValue={inputValue}
                  disable={disableBtns || isLoading}
                  allItems={currentData}
                />
              )}
               {item.uiCommand === "WC26TABLE" && (
                <WC26TABLE
                  item={item}
                  handleClick={handleClick}
                  disable={disableBtns}
                />
              )}
              {item.uiCommand === "A1ListSchedule" && (
                <A1ListSchedule data={item.text_data || item.text || item} />
              )}

               {item.uiCommand === "A23SingleSelect" && (
                <A23SingleSelect data={item} code={item?.code} handleClick={handleClick} disable={disableBtns} setTextOnClick={setTextOnClick} />
              )}

              {item.uiCommand === "A1e" &&
                secureLocalStorage.setItem("specialCode", item.code)}

              {item.uiCommand === "A80" && (
                <>
                  {props.setIsChatWithUs(true)}
                  <MessageA80
                    userClickedOnYes={props.userClickedOnYes}
                    disconnectInA80={props.disconnectInA80}
                    closeFeedBackIframe={props.closeFeedBackIframe}
                    setAgentScreenFunction={props.setAgentScreenFunction}
                    setInteractionIdFunction={props.setInteractionIdFunction}
                    fetchFeedbackUrlApi={() => props.fetchFeedbackUrlApi()}
                    item={item}
                    handleClick={handleClick}
                    tag={item.uiCommand}
                    chatClosed={props.chatClosed}
                    setUserDataForAgent={props.setUserDataForAgent}
                    {...props}
                  />
                </>
              )}
            </li>
          );
        })}</ul>
      : currentData &&
        // !chatEnd &&
        !finalTimerFlag &&
        currentData.map((item, index) => {
          console.log(finalTimerFlag);
          return (
            <div style={{ width: "100%" }}>
              {item.uiCommand === "idle" && (
                <div className="idle-wrap">{item.text}</div>
              )}{" "}
            </div>
          );
        });

  useEffect(() => {
    if (data) {
      setMessages([...messages, data]);
    }
  }, [currentData]);

  return (
    <Fragment>
      {props.thirdOkay && (
        <div className="chat-box-wrapper">
          <div class="coach-screen-inner"></div>
        </div>
      )}
      {props.loginLoader ? (
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      ) : (
        <>
          {showRecharge && (
            <RechargeToast
              item={rechargeData}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
            />
          )}
          {showBanner && (
            <Banner
              item={bannerData}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
            />
          )}

          {initialLoading && !props.historyLoader && (
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          )}
          {showHistory && props.sth && (
            <>
              {" "}
              {props.historyLoader ? (
                <div class="spinner">
                  <div class="bounce1"></div>
                  <div class="bounce2"></div>
                  <div class="bounce3"></div>
                </div>
              ) : (
                <div> {historyData}</div>
              )}
            </>
          )}

          {messages}

          {props.isLoading && (
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          )}
        </>
      )}
      <div ref={messagesEndRef} style={{ height: "10px" }} />
    </Fragment>
  );
};

export default Conversation;
